import { render, staticRenderFns } from "./ItsStockScatterInBoundDetail.vue?vue&type=template&id=738a872a&scoped=true&"
import script from "./ItsStockScatterInBoundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockScatterInBoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockScatterInBoundDetail.vue?vue&type=style&index=0&id=738a872a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a872a",
  null
  
)

export default component.exports